/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable eqeqeq */
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Button, Modal, Table } from 'antd';
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../../constants/service.types';
import { NOTIFIES } from '../../../constants/system.keys';
import { openMessage, socketEmitEvent } from '../../../redux/actions';
import AddWhitelistDeviceComponent from '../Modals/AddWhitelistDevice';

const { confirm } = Modal;

const WhitelistDeviceTab = ({ namespace, isAdmin, isAuth, currentTab }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { whiteListDevices: listWhitelistDevices, deleteWhiteListDevice } =
    useSelector((state) => state);

  const [whiteListDevices, setWhiteListDevices] = useState();
  const [visibleAddWhiteListDevice, setVisibleAddWhiteListDevice] =
    useState(false);
  const [key, setKey] = useState(Math.random());

  useEffect(() => {
    if (listWhitelistDevices) {
      setWhiteListDevices(
        listWhitelistDevices.map((device, index) => ({
          ...device,
          index: index + 1,
          loading: false,
        })),
      );
    }
    return () => {
      setWhiteListDevices(null);
    };
  }, [listWhitelistDevices]);

  useEffect(() => {
    if (isAuth === 1 && namespace && isAdmin) {
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_WHITE_LIST_DEVICE_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAdmin, isAuth, namespace]);

  useEffect(() => {
    if (deleteWhiteListDevice) {
      const { data, message, result } = deleteWhiteListDevice;
      const { address } = data;
      if (result === 1) {
        openMessage(NOTIFIES.SUCCESS, message);
        setWhiteListDevices((state) =>
          state.filter((ip) => ip.address !== address),
        );
      } else {
        openMessage(NOTIFIES.ERROR, message);
        setWhiteListDevices((state) =>
          state.map((ip) =>
            ip.address !== address ? ip : { ...ip, loading: false },
          ),
        );
      }
    }
  }, [deleteWhiteListDevice]);

  const onAddWhitelistDevice = (requestId, values) => {
    const { address, namespace } = values;
    let data = {
      address,
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.ADD_WHITE_LIST_DEVICE,
      requestId,
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const handleAddWhiteListDeviceDone = useCallback((data) => {
    setVisibleAddWhiteListDevice(false);
    setKey(Math.random());
    return setWhiteListDevices((state) =>
      state && state.length > 0
        ? state.concat({
          index: state.length + 1,
          address: data.address,
          namespace: data.namespace,
          loading: false,
        })
        : [
          {
            index: 1,
            address: data.address,
            namespace: data.namespace,
            loading: false,
          },
        ],
    );
  }, []);

  const handleRemoveDevice = (index, address, namespace) => {
    confirm({
      title: t('_REMOVE_ADDRESS_FROM_WHITELIST_TITLE', { address: address }),
      icon: <ExclamationCircleOutlined />,
      okText: t('Remove'),
      onOk() {
        setWhiteListDevices((state) =>
          state.map((item) =>
            item.index !== index ? item : { ...item, loading: true },
          ),
        );
        let data = {
          address,
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.DELETE_WHITE_LIST_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      },
      onCancel() { },
    });
  };

  const onCancelWhiteListDevice = () => {
    setVisibleAddWhiteListDevice(false);
    setKey(Math.random());
  };

  return (
    <Fragment>
      <Modal
        visible={visibleAddWhiteListDevice}
        title={t('Add whitelist device')}
        onCancel={() => onCancelWhiteListDevice()}
        footer={null}
      >
        {visibleAddWhiteListDevice && (
          <AddWhitelistDeviceComponent
            key={key}
            namespace={namespace}
            onAdd={onAddWhitelistDevice}
            onDone={handleAddWhiteListDeviceDone}
          />
        )}
      </Modal>

      {currentTab === 'white-list-device' && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            paddingBottom: '5px',
          }}
        >
          <Button onClick={() => setVisibleAddWhiteListDevice(true)}>
            {t('Add whitelist device')}
          </Button>
        </div>
      )}
      <Table
        loading={!whiteListDevices}
        columns={[
          {
            title: t('Index'),
            dataIndex: 'index',
            key: 'id_ip',
          },
          {
            title: t('MAC Address'),
            dataIndex: 'address',
            key: 'ipAddress_ip',
          },
          {
            title: t('Namespace'),
            dataIndex: 'namespace',
            key: 'namespace_ip',
          },
          {
            title: t('Action'),
            key: 'action-share-device',
            width: 120,
            render: (ip) => (
              <div className="manager-member-actions">
                <div
                  className="edit-button"
                  onClick={() =>
                    handleRemoveDevice(ip.index, ip.address, ip.namespace)
                  }
                >
                  <DeleteOutlined /> {t('Remove')}
                </div>
              </div>
            ),
          },
        ]}
        dataSource={
          whiteListDevices &&
          whiteListDevices.map((device) => ({
            ...device,
            key: device.index,
          }))
        }
      />
    </Fragment>
  );
};

export default WhitelistDeviceTab;
